<template>
  <ServersTableComponent :readOnly="false" />
</template>

<script>
import ServersTableComponent from "@/components/wizard/ServersTableComponent";

export default {
  components: {
    ServersTableComponent,
  },
};
</script>